module.exports = __webpack_public_path__ + "img/2016_0.889c5b25.webp";